import { FEATURE_MEDIA } from '../constants';

export function publicAssetUrl(path) {
  if (!path) return null;
  const base = process.env.PUBLIC_URL || '';
  return encodeURI(`${base}${path}`);
}

/** Resolve one or more image URLs for a feature slot and locale. */
export function getFeatureMediaSrcs(mediaKey, language) {
  const entry = FEATURE_MEDIA[mediaKey];
  if (!entry) return [];
  const locale = language === 'zh' ? 'zh' : 'en';
  const raw = entry[locale];
  const paths = Array.isArray(raw) ? raw : raw ? [raw] : [];
  return paths.map(publicAssetUrl).filter(Boolean);
}
